module.exports = __webpack_public_path__ + "img/auditResults_a.c1f7f729.svg";